import { leadService } from '../../helpers/services/lead.service'
import { sharedHelper } from '@/utils'

export const state = {
  list: [],
  pagination: {},
  stats: {},
  details: {},
  status: { list: true, detail: true, save: true },
  lastError: null,
}

export const LEAD_MODULE = 'lead'

export const GET_ALL_LEADS = 'getAllLeads'
export const GET_LEAD_STATS = 'getLeadStats'
export const GET_LEAD = 'getLead'
export const CREATE_LEAD = 'createLead'
export const UPDATE_LEAD = 'updateLead'
export const DELETE_LEAD = 'deleteLead'
export const CONVERT_LEAD = 'convertLead'
export const ASSIGN_LEAD = 'assignLead'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const STATS_SUCCESS = 'statsSuccess'
const DETAIL_SUCCESS = 'detailSuccess'

export const actions = {
  [GET_ALL_LEADS]({ commit }, { filter } = {}) {
    commit(REQUESTING, 'list')
    return leadService.getAll(filter || {}).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e)
    })
  },
  [GET_LEAD_STATS]({ commit }) {
    return leadService.getStats().then((r) => {
      commit(STATS_SUCCESS, r); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_LEAD]({ commit }, { uuid }) {
    commit(REQUESTING, 'detail')
    return leadService.get(uuid).then((r) => {
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e)
    })
  },
  [CREATE_LEAD]({ commit }, { payload }) {
    commit(REQUESTING, 'save')
    return leadService.create(payload).then((r) => {
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e); return null
    })
  },
  [UPDATE_LEAD]({ commit }, { uuid, payload }) {
    commit(REQUESTING, 'save')
    return leadService.update(uuid, payload).then((r) => {
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e); return null
    })
  },
  [DELETE_LEAD]({ commit }, { uuid }) {
    commit(REQUESTING, 'save')
    return leadService.remove(uuid).then(() => {
      commit(SUCCESS); return true
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e); return false
    })
  },
  [CONVERT_LEAD]({ commit }, { uuid, debtorCode }) {
    commit(REQUESTING, 'save')
    return leadService.convert(uuid, debtorCode).then((r) => {
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e); return null
    })
  },
  [ASSIGN_LEAD]({ commit }, { uuid, assignedTo }) {
    commit(REQUESTING, 'save')
    return leadService.assign(uuid, assignedTo).then((r) => {
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e); return null
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    state.list = data?.data || []
    state.pagination = data?.pagination || {}
  },
  [STATS_SUCCESS](state, data) {
    state.stats = data?.data || {}
  },
  [DETAIL_SUCCESS](state, data) {
    state.details = data?.data || {}
  },
  [FAILURE](state, error) {
    state.status = { list: true, detail: true, save: true }
    state.lastError = error || null
  },
  [REQUESTING](state, type) {
    state.status[type] = false
    state.lastError = null
  },
  [SUCCESS](state) { state.status = { list: true, detail: true, save: true } },
}
